import { useEffect, useState } from 'react'

/** The time now, read again every `everyMs` while `active`. */
export const useNow = (everyMs: number, active = true): Date => {
	const [now, setNow] = useState(() => new Date())
	useEffect(() => {
		if (!active) {
			return
		}
		setNow(new Date())
		const timer = window.setInterval(() => setNow(new Date()), everyMs)
		return () => window.clearInterval(timer)
	}, [active, everyMs])
	return now
}
